import { xpathElementConverter } from './xpath-converter';
import { TimeUnit } from './translates';
import { TimeComparator } from 'z3k-config';
export function getWeekdays(el) {
    const monday = Number(xpathElementConverter(el, 'field[@name="Mo"]').textContent === 'TRUE') <<
        0;
    const tuesday = Number(xpathElementConverter(el, 'field[@name="Tu"]').textContent === 'TRUE') <<
        1;
    const wednesday = Number(xpathElementConverter(el, 'field[@name="We"]').textContent === 'TRUE') <<
        2;
    const thursday = Number(xpathElementConverter(el, 'field[@name="Th"]').textContent === 'TRUE') <<
        3;
    const friday = Number(xpathElementConverter(el, 'field[@name="Fr"]').textContent === 'TRUE') <<
        4;
    const saturday = Number(xpathElementConverter(el, 'field[@name="Sa"]').textContent === 'TRUE') <<
        5;
    const sunday = Number(xpathElementConverter(el, 'field[@name="Su"]').textContent === 'TRUE') <<
        6;
    return monday | tuesday | wednesday | thursday | friday | saturday | sunday;
}
export const timeUnitsDict = {
    1: 1000, // секунды
    2: 1000 * 60, // минуты
    3: 1000 * 60 * 60, // Часы
    4: 1000 * 60 * 60 * 24, // дни
};
export function getUnitTime(time) {
    if (time % timeUnitsDict[4] == 0) {
        return [TimeUnit.DAY, time / timeUnitsDict[4]];
    }
    if (time % timeUnitsDict[3] == 0) {
        return [TimeUnit.HOUR, time / timeUnitsDict[3]];
    }
    if (time % timeUnitsDict[2] == 0) {
        return [TimeUnit.MIN, time / timeUnitsDict[2]];
    }
    if (time % timeUnitsDict[1] == 0) {
        return [TimeUnit.SEC, time / timeUnitsDict[1]];
    }
    return [TimeUnit.SEC, time];
}
export function addWeekdaysToTimeComparators(config, days_of_the_week) {
    return TimeComparator.get.add(config, {
        daysOfTheWeek: days_of_the_week,
        time: 0,
        comparator_type: 0,
        type: TimeComparator.Type.WEEKDAYS,
    });
}
export function addTimeComparatorToTimeComparators(config, comparator_type, hour, min) {
    const time = (hour << 8) | min;
    return TimeComparator.get.add(config, {
        daysOfTheWeek: 0,
        time,
        comparator_type,
        type: TimeComparator.Type.TIME,
    });
}
